import axios from "axios";
import * as moment from "moment/moment";
import { SYSTEM_ROLES_NAME } from "@/helpers/constants";

// รายงาน WhatsApp delivery ดูได้เฉพาะหัวหน้างาน
export const WHATSAPP_REPORT_ROLES = [
  SYSTEM_ROLES_NAME.SUPERADMIN,
  SYSTEM_ROLES_NAME.SUPERVISOR
];

export const WHATSAPP_REPORT_PATH = "/report/whatsapp-delivery";

export const canViewWhatsappReport = adminProfile =>
  !!adminProfile && WHATSAPP_REPORT_ROLES.includes(adminProfile.userType);

// ตัด .0 ทิ้ง เช่น 2.0 → "2", 2.5 → "2.5"
const trimNumber = value => String(Number(value.toFixed(1)));

// วินาที → ข้อความอ่านง่าย (ไม่มีข้อมูล = "-")
export const formatDuration = (seconds, count) => {
  if (!count) return "-";
  const value = Math.max(seconds, 0);
  if (value < 1) return "ไม่ถึง 1 วินาที";
  if (value < 60) return `${trimNumber(value)} วินาที`;
  if (value < 3600) return `${trimNumber(value / 60)} นาที`;
  return `${trimNumber(value / 3600)} ชั่วโมง`;
};

// % ที่ถึงเครื่องลูกค้าภายใน 10 วินาที
export const within10sPercent = row =>
  row && row.deliveredCount
    ? `${((row.delivered0To10s / row.deliveredCount) * 100).toFixed(1)}%`
    : "-";

// axios ตัวหลักมี interceptor ที่เขียนทับ header ทั้งหมดด้วย API-KEY เดิม
// จึงใช้ instance แยกเพื่อส่ง $headersChat (VUE_APP_HEADERS_API_KEY) ได้ถูกต้อง
const whatsappHttp = axios.create();

export const getWhatsappDelivery = (baseUrl, headers, params) =>
  whatsappHttp.get(`${baseUrl}/WhatsappReport/delivery`, { headers, params });

// navbar กับการ์ดในหน้าแชทเรียกพร้อมกัน → ใช้ผลเดียวกันภายใน 1 นาที
const CACHE_MS = 60 * 1000;
const todayCache = {};

// สรุปของวันนี้ (null = ยังไม่มีข้อมูล / ดึงไม่สำเร็จ)
export const fetchWhatsappDeliveryToday = (
  baseUrl,
  headers,
  brandId,
  force = false
) => {
  const today = moment().format("YYYY-MM-DD");
  const key = `${brandId}|${today}`;
  const cached = todayCache[key];
  if (!force && cached && Date.now() - cached.time < CACHE_MS)
    return cached.promise;

  const promise = getWhatsappDelivery(baseUrl, headers, {
    from: today,
    to: today,
    brandId
  })
    .then(response => {
      const detail = response.data.result == 1 ? response.data.detail : [];
      return (detail || []).find(x => x.date === today) || null;
    })
    .catch(() => {
      delete todayCache[key];
      return null;
    });
  todayCache[key] = { time: Date.now(), promise };
  return promise;
};
